export default "__VITE_ASSET__qVseKmM4__"